import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";

// Toast do término da mesclagem — só para quem pediu (#4408).
// Importa toast e i18n aqui dentro: passar `i18n.t` solto como argumento
// perdia o `this` do i18next e quebrava com "reading 'translator'".
// O `error` do evento é um código (ERR_...) ou, no fim das retentativas, a
// mensagem crua do erro (pode ser SQL). Só mostra o que tem tradução.
const failureText = code => {
  const key = `backendErrors.${code}`;
  if (code && i18n.exists(key)) return i18n.t(key);
  return i18n.t("contacts.toasts.mergeFailedGeneric");
};

export const notifyMergeFinished = (data, userId) => {
  if (!data || Number(data.requestedBy) !== Number(userId)) return false;
  // "running" é progresso (barra na linha), não término
  if (data.status !== "done" && data.status !== "failed") return false;
  if (data.status === "done") toast.success(i18n.t("contacts.toasts.mergeDone"));
  else toast.error(`${i18n.t("contacts.toasts.mergeFailed")}: ${failureText(data.error)}`);
  return true;
};
